import React from 'react';
import cn from 'classnames';
import { Link } from '@landing/ui';
import { Contacts } from 'components/UI';

import * as styles from './Footer.module.scss';

export default function Footer({ anchorLinks, address, phone, email }) {
  return (
    <footer className={styles.footer} id="footer">
      <div className={styles.layout}>
        <Link href="https://andersenlab.com" className={cn(styles.logoWrap, styles.showMobile)}>
          <div className={styles.logo} />
        </Link>
        <div className={styles.info}>
          <p className={styles.address}>{address}</p>
          <Contacts className={styles.contacts} />
        </div>
        <div className={styles.navigationWrapper}>
          <Link href="https://andersenlab.com" className={cn(styles.logoWrap, styles.showTablet)}>
            <div className={styles.logo} />
          </Link>
          <div className={styles.navigation}>
            {anchorLinks?.map(({ alias, title }) => (
              <Link key={title} className={styles.link} href={alias}>
                {title}
              </Link>
            ))}
          </div>
          <span className={styles.copyright}>© 2023 Andersenlab.com</span>
        </div>
      </div>
    </footer>
  );
}
